var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgGroupsAndPoolsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Org_Groups_and_Pools_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Org_Groups_and_Pools_Normal",
    "data-name": "Org Groups and Pools_Normal",
    clipPath: "url(#clip-Org_Groups_and_Pools_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Org_Groups_and_Pools",
    "data-name": "Org Groups and Pools",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150",
    transform: "translate(0 4.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2144",
    "data-name": "Group 2144",
    transform: "translate(0 7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4711",
    "data-name": "Path 4711",
    d: "M16.468,17.333v-.169a3.542,3.542,0,0,0-3.483-2.884H9.963A3.542,3.542,0,0,0,6.48,17.164V19.2a.891.891,0,0,0,.89.89h8.239a.891.891,0,0,0,.89-.89V17.333Z",
    transform: "translate(-5.851 -13.697)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4712",
    "data-name": "Path 4712",
    d: "M15.812,20.927H7.574a1.506,1.506,0,0,1-1.5-1.5V17.552a.85.85,0,0,1,.031-.276A4.161,4.161,0,0,1,10.2,13.9H13.22a4.189,4.189,0,0,1,4.1,3.375,1.691,1.691,0,0,1,.031.276v1.872a1.506,1.506,0,0,1-1.5,1.5Zm-5.631-5.8A2.953,2.953,0,0,0,7.3,17.505v1.918a.259.259,0,0,0,.261.261H15.8a.259.259,0,0,0,.261-.261V17.505a2.929,2.929,0,0,0-2.884-2.378H10.151Z",
    transform: "translate(-6.07 -13.9)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145",
    transform: "translate(2.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    d: "M13.391,12.046A2.716,2.716,0,1,1,10.676,9.33,2.711,2.711,0,0,1,13.391,12.046Z",
    transform: "translate(-7.346 -8.732)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    d: "M10.889,15.6a3.329,3.329,0,1,1,3.329-3.329A3.326,3.326,0,0,1,10.889,15.6Zm0-5.431a2.1,2.1,0,1,0,2.1,2.1A2.105,2.105,0,0,0,10.889,10.167Z",
    transform: "translate(-7.56 -8.94)",
    fill: "#6f8b8f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(18.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147",
    transform: "translate(0 7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    d: "M29.008,17.333v-.169a3.542,3.542,0,0,0-3.483-2.884H22.5a3.542,3.542,0,0,0-3.483,2.884V19.2a.891.891,0,0,0,.89.89h8.239a.891.891,0,0,0,.89-.89V17.333Z",
    transform: "translate(-18.376 -13.697)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4716",
    "data-name": "Path 4716",
    d: "M28.342,20.927H20.1a1.506,1.506,0,0,1-1.5-1.5V17.552a.85.85,0,0,1,.031-.276,4.161,4.161,0,0,1,4.1-3.375H25.75a4.189,4.189,0,0,1,4.1,3.375,1.691,1.691,0,0,1,.031.276v1.872a1.506,1.506,0,0,1-1.5,1.5Zm-5.615-5.8a2.953,2.953,0,0,0-2.884,2.378v1.918a.259.259,0,0,0,.261.261h8.239a.259.259,0,0,0,.261-.261V17.505a2.929,2.929,0,0,0-2.884-2.378H22.7Z",
    transform: "translate(-18.6 -13.9)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2148",
    "data-name": "Group 2148",
    transform: "translate(2.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4717",
    "data-name": "Path 4717",
    d: "M25.931,12.046A2.716,2.716,0,1,1,23.216,9.33,2.711,2.711,0,0,1,25.931,12.046Z",
    transform: "translate(-19.886 -8.732)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4718",
    "data-name": "Path 4718",
    d: "M23.429,15.6a3.329,3.329,0,1,1,3.329-3.329A3.326,3.326,0,0,1,23.429,15.6Zm0-5.431a2.1,2.1,0,1,0,2.1,2.1A2.105,2.105,0,0,0,23.429,10.167Z",
    transform: "translate(-20.1 -8.94)",
    fill: "#6f8b8f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151",
    transform: "translate(7.758 14.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    "data-name": "Path 4719",
    d: "M19.561,24.2H23.9a1.012,1.012,0,0,0,1.013-1.013V20.534a1.047,1.047,0,0,0-.015-.184,4.691,4.691,0,0,0-4.6-3.82H16.308a4.679,4.679,0,0,0-4.6,3.82c0,.061-.015.123-.015.184v2.654A1.012,1.012,0,0,0,12.7,24.2h2.071",
    transform: "translate(-11.076 -15.901)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    d: "M24.116,25.034H19.774a.614.614,0,0,1,0-1.227h4.342a.406.406,0,0,0,.4-.4V20.677a4.078,4.078,0,0,0-4-3.314H16.522a4.09,4.09,0,0,0-4,3.314v2.731a.406.406,0,0,0,.4.4h2.071a.614.614,0,0,1,0,1.227H12.916a1.627,1.627,0,0,1-1.626-1.626V20.753a1.044,1.044,0,0,1,.031-.307,5.324,5.324,0,0,1,5.216-4.327h3.989a5.309,5.309,0,0,1,5.216,4.327,1.889,1.889,0,0,1,.031.307v2.654a1.627,1.627,0,0,1-1.626,1.626Z",
    transform: "translate(-11.29 -16.12)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4721",
    "data-name": "Path 4721",
    d: "M15.61,22.357h-.276a.614.614,0,1,1,0-1.227h.276a.614.614,0,1,1,0,1.227Z",
    transform: "translate(-1.678 1.373)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    "data-name": "Group 2152",
    transform: "translate(10.781 5.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    d: "M20.84,14.11a3.59,3.59,0,1,1-3.59-3.59A3.595,3.595,0,0,1,20.84,14.11Z",
    transform: "translate(-13.046 -9.906)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    d: "M17.464,18.528a4.2,4.2,0,1,1,4.2-4.2A4.21,4.21,0,0,1,17.464,18.528Zm0-7.165a2.976,2.976,0,1,0,2.976,2.976A2.979,2.979,0,0,0,17.464,11.363Z",
    transform: "translate(-13.26 -10.12)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4724",
    "data-name": "Path 4724",
    d: "M11.715,9.2a.591.591,0,0,1-.537-.322.625.625,0,0,1,.23-.844,15.064,15.064,0,0,1,14.391,0,.621.621,0,1,1-.6,1.089,13.792,13.792,0,0,0-13.195,0A.7.7,0,0,1,11.7,9.2Z",
    transform: "translate(-3.634 -6.208)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4725",
    "data-name": "Path 4725",
    d: "M20.192,28.533a14.4,14.4,0,0,1-7.927-2.363,14.858,14.858,0,0,1-4.076-3.958l-.406-.6a.627.627,0,0,1,.18-.859.6.6,0,0,1,.842.184l.361.552a13.762,13.762,0,0,0,3.745,3.636A13.282,13.282,0,0,0,17.8,27.076a13.271,13.271,0,0,0,10.183-2.317,13.958,13.958,0,0,0,3.565-3.8.6.6,0,0,1,.842-.184.627.627,0,0,1,.18.859,14.775,14.775,0,0,1-9.055,6.521,14.264,14.264,0,0,1-3.324.384Z",
    transform: "translate(-5.207 1.018)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgGroupsAndPoolsNormal);
export default __webpack_public_path__ + "static/media/Org_Groups_and_Pools_Normal.54f18f65a0fb5d3c798d1ac2ad38cee0.svg";
export { ForwardRef as ReactComponent };